/**
 * @module components/user-type-modal
 * @requires module:common/utils/cookie~Cookie
 */
import { Modal } from '@roskvartal-landings/component-modal';
import { Cookie } from '@/common/utils';

const rkMarkerCookie = Cookie.get('.RkMarker');
const rkMarkerStorage = JSON.parse(localStorage.getItem('rkMarker') || '{}');

if (!rkMarkerStorage.userActions) {
  rkMarkerStorage.userActions = {};
}

const parseUserActions = (actions) => {
  rkMarkerStorage.userActions = {};

  if (!actions) {
    return;
  }

  actions.split('&').forEach((action) => {
    const arr = action.split('=');

    if (arr[0]) {
      rkMarkerStorage.userActions[arr[0]] = arr[1];
    }
  });
};

const insertMetricsIframe = () => {
  let userActions = '';
  for (const prop in rkMarkerStorage.userActions) {
    if (userActions) {
      userActions += '&';
    } else {
      userActions = '?';
    }

    userActions += `${prop}=${rkMarkerStorage.userActions[prop]}`;
  }

  document.body.insertAdjacentHTML(
    'beforeend',
    `<iframe
      src="${window.rkMarkerApi}/iframe/${rkMarkerCookie}${userActions}"
      height="0"
      width="0"
    ></iframe>`
  );
};

/**
* @extends module:components/modal~Modal
* @inheritdoc
* @classdesc Компонент модального окна подтверждения типа пользователя
*/
class UserTypeModal extends Modal {
  constructor(el) {
    super(el);
    this.init();
  }

  /**
  * @method
  * @description Инициализация модалки
  */
  init() {
    if (document.readyState === 'complete') {
      this.getUserActions();
      return;
    }

    window.addEventListener('load', () => {
      this.getUserActions();
    });
  }

  getUserActions() {
    if (
      rkMarkerStorage.expiration &&
      rkMarkerStorage.expiration > Date.now()
    ) {
      insertMetricsIframe();
      return;
    }

    const data = {
      userId: rkMarkerCookie
    };

    window.addEventListener('message', this.receiveMessage.bind(this));
    window.RK_METRICS.getUserActions(data);
  }

  receiveMessage(evt) {
    if (!evt.data) {
      return;
    }

    switch (evt.data.type) {
      case 'getUserActions': {
        parseUserActions(evt.data.payload);
      }
      case 'saveUserAction': {
        this.saveUserActions();
        insertMetricsIframe();
        break;
      }
    }
  }

  chooseUserType() {
    const organization = this.refs.get('organization');
    const owner = this.refs.get('owner');
    const cancelBtn = this.refs.get('cancel-btn');

    const inputHandler = () => {
      cancelBtn.disabled = false;
    };

    organization.addEventListener('change', inputHandler);
    owner.addEventListener('change', inputHandler);

    cancelBtn.addEventListener('click', () => {
      this.sendUserAction()
    });

    this.open();
  }

  sendUserAction() {
    rkMarkerStorage.userActions.userType =
      document.querySelector('.user-type-modal__input:checked').value;
    const data = {
      userId: rkMarkerCookie,
      key: 'userType',
      value: rkMarkerStorage.userActions.userType
    };

    window.RK_METRICS.saveUserAction(data);
    this.close();
  }

  saveUserActions() {
    rkMarkerStorage.expiration = Date.now() + 3600 * 1000;
    localStorage.setItem('rkMarker', JSON.stringify(rkMarkerStorage));

    window.removeEventListener('message', this.receiveMessage);
  }
}

export default UserTypeModal;
